<template>
  <SplitContainer
    class="pb-24"
    color="#FFF6E9"
  >
    <template #head>
      <div class="grid-side-content grid gap-5 py-5 lg:pb-7 lg:pt-8">
        <div class="flex flex-col py-2.5">
          <div class="heading text-blue pb-5 font-bold">
            {{ member.title }}
          </div>
        </div>
      </div>
    </template>

    <template #split>
      <div class="grid-base border-blue grid-cols-1 border bg-white p-5 xl:grid-cols-3">
        <div class="flex flex-col">
          <img
            v-if="member.active_image"
            class="h-full object-contain"
            :src="member.active_image.url"
          >
        </div>
        <div class="flex flex-col sm:px-5">
          <div class="text-black">
            <div class="mb-4">
              <p class="text-base font-bold">
                {{ member.title }}
              </p>
            </div>
            <div
              v-for="sector in member.sectors"
              :key="sector.id"
              class="text-blue font-bold"
            >
              - {{ sector.title }}
            </div>
          </div>

          <div class="mt-4 flex flex-col">
            <p class="text-base font-medium">
              {{ member.address }}
            </p>
            <p class="mb-2 text-base font-medium">
              {{ member.zipcode + ' ' + member.city }}
            </p>
            <a
              class="p-0 text-base font-medium text-black underline hover:font-semibold"
              :href="`tel:${member.mobile_number}`"
            >
              {{ member.mobile_number }}
            </a>
            <a
              class="p-0 text-base font-medium text-black underline hover:font-semibold"
              :href="`mailto:${member.email}`"
            >
              {{ member.email }}
            </a>
          </div>
        </div>
        <div class="flex flex-col">
          <img
            src="~/assets/images/netherlands.svg"
            class="max-w-[600px]"
            alt=""
          >
        </div>
      </div>
      <div class="bg-green relative mx-auto -mt-6 w-max rounded-full px-4 py-2.5 lg:sticky lg:right-52 lg:-mt-6">
        <a
          class="text-lg font-bold text-white no-underline"
          :href="`${member.website}`"
          rel="noopener"
        >
          {{ website }}
        </a>
      </div>
    </template>
  </SplitContainer>
</template>

<script setup lang="ts">
import memberQuery from '~/graphql/queries/members/member.gql';
import type {Bedrijf} from '~/graphql/graphql';

const route = useRoute();

const member = await getMember(route.params.slug);

async function getMember(slug: string | string[]) {
  const {data} = await useAsyncQuery<{ member: Bedrijf }>(memberQuery, {slug});

  if (!data.value) {
    showError({statusCode: 404});
  }

  return data.value!.member;
}

const website = computed(() => member.website?.replace(/^https?:\/\//, '').replace(/^\/|\/$/g, ''));
</script>
